exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.info-container[data-v-bea0ce4c] {\n  display: block;\n  position: absolute;\n  background-color: rgb(80, 80, 80);\n  width: 50%;\n  left: 25%;\n  top: 0;\n  border: 1.5px solid #c8c8c8;\n  color: var(--font-color);\n}\n.error[data-v-bea0ce4c] {\n  background-color: rgb(170, 113, 110);\n}\np[data-v-bea0ce4c] {\n  margin-bottom: 0px;\n}\nh3[data-v-bea0ce4c] {\n  color: white;\n  text-shadow: 0px 0px 2px black;\n  font-weight: normal;\n  font-size: 1.3vw;\n  margin-bottom: 8px;\n  margin-top: 0px;\n}\n", ""]);

// exports
